<template>
    <Tooltip
        :disabled="disabled"
        :content="content"
        :placement="placement"
        :transfer="transfer"
        :maxWidth="maxWidth"
        style="width:100%;"
    >
        <div class="ellipsisContent" ref="ellipsisContent" >
            <slot></slot>
        </div>
        <div v-if="custom" slot="content">
            <slot name=content></slot>
        </div>
    </Tooltip>
</template>

<script>
    export default {
        name: "DshTags",
        props: {
            content: String,
            propsObj: {
                type: Object,
                default () {
                    return {};
                }
            },
            placement: {
                type: String,
                default: "bottom"
            },
            maxWidth: {
                type: String,
                default: "200"
            },
            transfer: {
                type: Boolean,
                default: false
            },
            custom: Boolean
        },
        data () {
            return {
                disabled: false
            };
        },
        computed: {
        },
        methods: {
            computedDisable () {
                // 获取overflow：hidden元素的实际被撑开的宽度
                let test = this.$refs.ellipsisContent;
                let cp = test.cloneNode(true);
                cp.style.cssText = "all: unset;position: absolute;opacity:0;";
                test.parentElement.appendChild(cp);
                let realWidth = cp.offsetWidth;
                cp.remove();
                this.disabled = realWidth <= test.offsetWidth;
            }
        },
        created () {},
        mounted () {
            this.$nextTick(() => {
                this.computedDisable();
            });
        },
        updated () {
            this.$nextTick(() => {
                this.computedDisable();
            });
        },
        watch: {
            content () {
                this.$nextTick(() => {
                    this.computedDisable();
                });
            }
        }
    };
</script>

<style lang="less" scoped>
    .Ctooltip {
    }
</style>
<style lang="less">
    .Ctooltip {

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/small/Ctooltip.vue